import { useEffect } from 'react'
import type { Lang } from '../types'

const origin = 'https://www.plays100.com'

function meta(selector: string, attributes: Record<string, string>) {
  let node = document.head.querySelector<HTMLMetaElement>(selector)
  if (!node) { node = document.createElement('meta'); document.head.appendChild(node) }
  Object.entries(attributes).forEach(([key, value]) => node!.setAttribute(key, value))
}

function link(rel: string, href: string, hreflang?: string) {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`
  let node = document.head.querySelector<HTMLLinkElement>(selector)
  if (!node) { node = document.createElement('link'); node.rel = rel; document.head.appendChild(node) }
  node.href = href
  if (hreflang) node.hreflang = hreflang
}

export function useSeo(title: string, description: string, path: string, lang: Lang, jsonLd?: object, options: { noindex?: boolean } = {}) {
  useEffect(() => {
    const suffix = lang === 'zh' ? '?lang=zh' : ''
    const canonical = `${origin}${path}${suffix}`
    document.title = title
    meta('meta[name="description"]', { name: 'description', content: description })
    meta('meta[property="og:title"]', { property: 'og:title', content: title })
    meta('meta[property="og:description"]', { property: 'og:description', content: description })
    meta('meta[property="og:url"]', { property: 'og:url', content: canonical })
    meta('meta[name="robots"]', { name: 'robots', content: options.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' })
    link('canonical', canonical)
    link('alternate', `${origin}${path}`, 'en')
    link('alternate', `${origin}${path}?lang=zh`, 'zh-Hans')
    link('alternate', `${origin}${path}`, 'x-default')
    document.getElementById('route-jsonld')?.remove()
    if (jsonLd) {
      const script = document.createElement('script')
      script.id = 'route-jsonld'; script.type = 'application/ld+json'; script.textContent = JSON.stringify(jsonLd)
      document.head.appendChild(script)
    }
  }, [title, description, path, lang, jsonLd, options.noindex])
}
